import React from "react";

import { H2RButton } from "./imports";
import { cueDesign } from "./shared/Cue";
import { faClose } from "@fortawesome/free-solid-svg-icons";

export default function Sidebar({
	title = "",
	type = false,
	subtitle = "",
	open,
	onDone,
	children,
}) {
	return (
		<section
			style={{
				minWidth: open ? "20rem" : "0rem",
				maxWidth: open ? "20rem" : "0rem",
			}}
			className={`bg-gray-800  ${
				open ? "translate-x-0" : "translate-x-full w-0"
			} z-20 transform transition-transform duration-300 ease-in-out overflow-auto absolute top-0 bottom-0 right-0 shadow-2xl flex flex-col md:sticky`}
		>
			<div className="flex items-center py-3 px-3 border-b-2 border-gray-700">
				{type && (
					<span className={`rounded w-14 ${cueDesign(type).iconColour}`}>
						<svg
							width="56"
							height="48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							{cueDesign(type).icon}
						</svg>
					</span>
				)}
				<div className="ml-4 leading-3">
					<h2 className="capitalize text-sm font-semibold">
						{/* {cue.type.replace("_", " ")} */}
						{title}
					</h2>
					{/* <span className="text-xs text-gray-500">ID: {cue.id}</span> */}
					<span className="text-xs text-gray-500 select-text">{subtitle}</span>
				</div>
			</div>
			<div className="px-2 py-2 flex-grow overflow-auto">{children}</div>

			<div className="px-3 py-3 w-full bottom-0 border-t-2 bg-gray-800 border-gray-700">
				<H2RButton
					text="Close"
					size="small"
					icon={faClose}
					colour="dark"
					onClick={() => {
						return onDone();
					}}
				/>
			</div>
		</section>
	);
}
